/**
 * Serialize table filter payloads for API query strings.
 */

export function formatProductChoiceLabel(item) {
    if (!item) {
        return "";
    }
    if (item.upc && item.name) {
        return `${item.upc} — ${item.name}`;
    }
    return item.name || item.upc || String(item.id);
}

export function normalizeKpiFiltersForForm(filters = {}) {
    const next = { ...filters };
    if (!next.product && Array.isArray(next.products) && next.products.length) {
        const first = next.products[0];
        next.product =
            typeof first === "object" && first != null ? first.id : first;
    } else if (!next.product && typeof next.products === "string" && next.products) {
        const ids = next.products.split(",").map((part) => part.trim()).filter(Boolean);
        if (ids.length === 1) {
            next.product = ids[0];
        }
    }
    delete next.products;
    return next;
}

export function normalizeKpiFiltersForSave(filters = {}) {
    const next = { ...filters };
    delete next.products;
    return next;
}

export function serializeProductsFilter(products) {
    if (products == null || products === "") {
        return undefined;
    }
    if (typeof products === "string") {
        return products;
    }
    if (!Array.isArray(products) || !products.length) {
        return undefined;
    }
    const ids = products
        .map((entry) =>
            typeof entry === "object" && entry != null ? entry.id : entry,
        )
        .filter((id) => id != null && id !== "")
        .map(String);
    if (!ids.length) {
        return undefined;
    }
    return ids.join(",");
}

/**
 * Migrate legacy catalog entry sale format filter key.
 * DRF reserves the "format" query param for response format (csv/json).
 */
export function migrateCatalogEntryFormatFilter(filters = {}) {
    const next = { ...filters };
    const legacyFormat = next.format;
    if (
        legacyFormat != null &&
        legacyFormat !== "" &&
        legacyFormat !== "csv" &&
        (next.sale_format == null || next.sale_format === "")
    ) {
        next.sale_format = legacyFormat;
    }
    if (legacyFormat != null && legacyFormat !== "csv") {
        delete next.format;
    }
    return next;
}

export function buildApiFilterParams(filters = {}, options = {}) {
    const { stripPagination = true } = options;
    const params = migrateCatalogEntryFormatFilter({ ...filters });

    if (stripPagination) {
        delete params.limit;
        delete params.offset;
        delete params.ordering;
    }

    const serializedProducts = serializeProductsFilter(params.products);
    delete params.products;

    if (serializedProducts) {
        const ids = serializedProducts.split(",").filter(Boolean);
        if (!params.product && ids.length === 1) {
            params.product = ids[0];
        } else {
            params.products = serializedProducts;
        }
    }

    return params;
}
